import api from '@/services/api';
import store from '@/store';
import { PageMapping } from '@/helpers/PageMappingHelpers';

export default {
  async mixinSendFiles_televerserFichiers(files, dossierClient) {
    const data = new FormData();
    // eslint-disable-next-line array-callback-return
    files.map((item) => {
      data.append('files', item);
    });

    if (dossierClient) {
      data.append(
        'dossierClient',
        new Blob([JSON.stringify(dossierClient)], { type: 'application/json' })
      );
    }

    return api
      .call('upload-doc', 'televersementSendFiles', 'POST', {
        data,
        headers: {
          'cache-control': 'no-cache',
          pragma: 'no-cache',
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        if (response.data.status === 'SUCCESS') {
          if (response.data) {
            const versionDonnees = response.data?.versionDonnees;
            store.commit('dossier/SET_DOSSIER_VERSION_DONNEES', versionDonnees);
          }
          throw { url: PageMapping.IDENTITE_DOCUMENTS_CONFIRMATION.siteUrl };
        } else if (
          response.data.status === 'ERROR' &&
          (response.data.msg === 'fichiers' || response.data.msg === 'transfert')
        ) {
          throw { url: PageMapping.ERREUR_GENERIQUE.siteUrl };
        }
      })
      .catch((error) => {
        if (error.url) {
          throw error;
        }
        throw { url: PageMapping.ERREUR_GENERIQUE.siteUrl };
      });
  },
};
